<template>
  <pt-counselor-detail class="pt-counselor-detail__page"></pt-counselor-detail>
</template>

<script>
import PtCounselorDetail from 'cps/pt-counselor-manage/pt-counselor-detail/withData'
export default {
  name: 'pt-counselor-detail__view',
  components: {
    'pt-counselor-detail': PtCounselorDetail
  }
}
</script>
